import { Routes } from 'react-router-dom';
import './index.css';
import TerminalController from './components/Terminal';

function App() {
  return (
    <div className="App">
      <TerminalController />
    </div>
  );
}

export default App;
